import {
  Grid,
  Box,
  Typography,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import StepperGuide from "src/components/StepperGuide";
import Booking from "src/utils/Booking";
import RenderTimeSlots from "src/views/general/booking-components/RenderTimeSlots";

const DateAndTimezone = ({
  errors,
  selectedTimezone,
  sessionList,
  selectedSessionTime,
  setSessionSelectedTime,
  selectedOffer,
  appForThisOffer,
  blockTimeOnSelectedDate,
  selectedDate,
  setError,
  userDateFormat,
  userTimeFormat,
  userMinimumBookingNotice,
  allUpcommingAppt,
  preparingSessionList,
  stepperGuideLength,
  overFlowTimeToRender,
  underFlowTimeToRender,
  nextButtonRef,
  coachDetails,
  customStyle,
}) => {
  const { t } = useTranslation();
  const [timeHover, setTimeHover] = React.useState(null);

  const handleSelectedTime = async (time) => {
    return Booking._dateandtime.handleSelectedTime(
      time,
      userMinimumBookingNotice,
      userDateFormat,
      userTimeFormat,
      setSessionSelectedTime,
      nextButtonRef,
      setError,
      t
    );
  };

  const filteredList = sessionList ?? [];

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "32px",
            pt: "42px",
            flexDirection: "column",
          }}
        >
          <Box>
            <StepperGuide
              length={stepperGuideLength}
              activeLength={[1, 2]}
              customStyle={customStyle}
            />
          </Box>

          <Box>
            <Typography
              sx={{
                fontFamily:
                  customStyle?.headingFont ?? "var(--font-grenettepromedium)",
                fontSize: "18px",
                lineHeight: "31px",
                alignItems: "center",
                color: customStyle?.textColor ?? "#060A2D",
              }}
            >
              {t("individual.booking.schedule.choose_schedule")}
            </Typography>

            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "18px",
                color: customStyle?.secondaryTextColor ?? "#878787",
                fontFamily: `var(--font-${customStyle?.bodyFont})`,
                mt: "4px",
              }}
            >
              {t("individual.booking.schedule.choose_schedule.description", {
                package: selectedOffer?.name,
              })}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          mt: "31px",
        }}
      >
        <Box>
          {/* availabitlity */}
          <Box
            style={{
              width: "100%",
            }}
          >
            <Box>
              <Box mb={"10px"}>
                <Typography
                  sx={{
                    fontFamily:
                      customStyle?.headingFont ??
                      "var(--font-grenettepromedium)",
                    fontSize: "10px",
                    lineHeight: "11px",
                    letterSpacing: "0.07em",
                    color: customStyle?.secondaryTextColor ?? "#878787",
                    textTransform: "uppercase",
                  }}
                >
                  {t("booking.placeholder.time_slots")}
                </Typography>

                {Boolean(errors?.time) && (
                  <FormHelperText error>
                    {" "}
                    {errors?.time?.message}{" "}
                  </FormHelperText>
                )}
              </Box>

              {selectedDate === null ? (
                <NoAvailableTime
                  message={t("booking.error.required.select_date")}
                />
              ) : (
                <Box className="session-time-scroll">
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {preparingSessionList ? (
                      <Box
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          mt: "10px",
                        }}
                      >
                        <CircularProgress size={20} />
                      </Box>
                    ) : filteredList?.length > 0 ? (
                      <Grid container spacing={"10px"}>
                        {filteredList?.map((time, key) => {
                          return (
                            <Grid item xs={6} sm={6} key={key}>
                              <Box key={key}>
                                <RenderTimeSlots
                                  selectedSessionTime={selectedSessionTime}
                                  time={time}
                                  handleSelectedTime={handleSelectedTime}
                                  timeHover={timeHover}
                                  setTimeHover={setTimeHover}
                                  userTimeFormat={userTimeFormat}
                                  _key={key}
                                  customStyle={customStyle}
                                />
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>
                    ) : (
                      <NoAvailableTime
                        message={t(
                          "booking.error.required.no_time_on_selected_date"
                        )}
                      />
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DateAndTimezone;

const NoAvailableTime = ({ message }) => (
  <Box
    sx={{
      height: "338px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#F2F2F2",
      width: "100%",
      borderRadius: "8px",
    }}
  >
    <Typography
      sx={{
        fontFamily: "var(--font-grenettepromedium)",
        fontSize: "10px",
        lineHeight: "11px",
        letterSpacing: "0.07em",
        color: "#A1A1A1",
        textTransform: "uppercase",
      }}
    >
      {message}
    </Typography>
  </Box>
);
